import { render, staticRenderFns } from "./ColorPickerButton.vue?vue&type=template&id=ceda4152&scoped=true"
import script from "./ColorPickerButton.vue?vue&type=script&lang=js"
export * from "./ColorPickerButton.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerButton.vue?vue&type=style&index=0&id=ceda4152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceda4152",
  null
  
)

export default component.exports